import protection from "../../assets/protection.png"
import geers from "../../assets/geers.png"
import spring from "../../assets/spring.png"
import wheel from "../../assets/wheel.png"
import blocks from "../../assets/blocks.png";

const data = [
    {
        title: "Manual and Automatic Transmission",
        description: "With Weglot, you don't have to start translation from scratch. You get a first layer of machine translation from the best machine translation tools (including DeepL) on the market. Then, use Weglot's post-editing features to make manual edits or work directly with professional translators.",
        img: geers
    },
    {
        title: "Optimized for multilingual SEO",
        description: "Share your business with the world - quite literally. Weglot displays your website under language subdomains and subdirectories, making your site multilingual SEO-friendly. No more multiple websites or duplicate content!",
        img: wheel
    },
    {
        title: "Secure and robust infrastructure.",
        description: "Your translations and data are stored securely on Amazon Web Services' professional and secure servers within the EU.",
        img: spring
    },
    {
        title: "Data protection and GDPR compliant.",
        description: "The translations stored on Weglot belong to you - you can do what you want with them. Weglot does not collect any personal data from website visitors and is therefore GDPR compliant.",
        img: protection
    },
    {
        title: "Simple and fast integration.",
        description: "Weglot integrates seamlessly with your website and adapts to your technology - no coding or extra developer time required. Just install Weglot, choose your translated language(s) and watch Weglot do the hard work for you. A multilingual website in minutes? It's that simple!",
        img: blocks
    }
]
export default data;